// extracted by mini-css-extract-plugin
export default {"loaderWrap":"Loader_loaderWrap__XxiT+","loader":"Loader_loader__DwtSp","rotation":"Loader_rotation__zW3DX"};